import { Column } from 'react-table'
import { columnGenerators } from '../../../../../../_metronic/helpers'

const header = [
  {
    label: 'S.N',
    value: 'id',
  },
  {
    label: 'Name',
    value: 'packageName',
  },
  // {
  //   label: 'Company name',
  //   value: 'companyDetails[name]',
  // },
  {
    label: 'Description',
    value: 'description',
  },
  // {
  //   label: 'Country',
  //   value: 'address[country]',
  // },
  {
    label: 'Household Connected',
    value: 'householdConnected',
  },
  {
    label: 'Plastic Prevented',
    value: 'plasticPrevented',
  },
  {
    label: 'Life Impacted',
    value: 'peopleImpacted',
  },
  {
    label: 'Package Type',
    value: 'packageType',
  },
  {
    label: 'Icon',
    value: 'packageLogo',
  },
  // {
  //   label: 'Logo',
  //   value: 'bussinessPermit',
  // },
  {
    action: ['edit'],
  },
]

const roleColumns: ReadonlyArray<Column<any>> = columnGenerators(header)

export { roleColumns }
